import React from 'react';
import { Grid, Typography, Paper } from '@mui/material';
import ConstructionIcon from '@mui/icons-material/Construction';

const ExecutiveOffice: React.FC = () => {
  return (
    <Grid container paddingLeft={2} paddingRight={2}>
      <Grid item xs={12} padding={2}>
        <Typography variant="h4" color="primary">
          Executive Office
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Paper
          sx={{
            p: 8,
            textAlign: 'center',
            minHeight: '400px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <ConstructionIcon
            sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }}
          />
          <Typography variant="h5" color="text.secondary" gutterBottom>
            Coming Soon
          </Typography>
          <Typography variant="body1" color="text.secondary">
            This page is under construction. Please check back later.
          </Typography>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default ExecutiveOffice;
